import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }

  ul, ol {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    padding-left: 1.5rem;
    font-size: 0.9rem;
  }

  ol {
    counter-reset: item;
  }

  ol > li {
    display: block;
    margin-bottom: 0.3rem;
    position: relative;
  }

  ol > li:before {
    content: counter(item) ". ";
    counter-increment: item;
    font-weight: bold;
    position: absolute;
    left: -1.5rem;
    width: 1.5rem;
    text-align: right;
  }

  ul > li {
    margin-bottom: 0.3rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyJa() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # Terms of Service

These Terms of Service (hereinafter referred to as "these Terms") set forth the terms and conditions for using this app (hereinafter referred to as "the Service"). Users shall use the Service in accordance with these Terms.

## Article 1 (Application)

These Terms apply to all relationships concerning the use of the Service. If separate provisions are established for the Service, such separate provisions shall also constitute part of these Terms. In case of any conflict between separate provisions and these Terms, the separate provisions shall prevail.

## Article 2 (Changes and Termination of Service Content)

The Service may change, add, or terminate service content with prior notice. Users accept this, and the Service shall not be liable for any damages related to content changes or termination.

## Article 3 (Prohibited Actions)

Users shall not engage in the following actions when using the Service:

1. Actions that violate laws or public order and morals
2. Actions related to criminal activities
3. Actions that interfere with the operation of the Service
4. Actions that infringe upon intellectual property rights, portrait rights, privacy rights, or other rights of third parties or the Service
5. Actions that collect or accumulate personal information about other users
6. Actions that provide false information
7. Actions such as unauthorized access, reverse engineering, decompiling, disassembling, or analyzing the Service's system
8. Spam actions or actions that damage the trust of the Service
9. Actions that may adversely affect the Service's network or system
10. Actions that use or intentionally spread software or code that may interfere with the Service's functions
11. Actions that damage the credit or reputation of the Service or third parties
12. Actions that violate these Terms or the Service's operating policies
13. Other actions deemed inappropriate by the Service

## Article 4 (Suspension of Service Provision)

The Service may temporarily suspend or interrupt service without prior notice due to maintenance, system failures, or other reasons. The Service shall not be liable for any damages caused by such suspension.

## Article 5 (Disclaimer and Exemption)

1. The Service does not guarantee the absence of factual or legal defects (including safety, reliability, accuracy, etc.).
2. The Service shall not be liable for any damages arising from the use of the Service.

## Article 6 (Intellectual Property Rights)

Intellectual property rights such as copyrights and trademarks related to the Service's content, design, and programs belong to the Service or third parties who legitimately own such rights. Users may not use these without authorization.

## Article 7 (Handling of Personal Information)

The Service shall appropriately handle users' personal information in accordance with the "Privacy Policy."

## Article 8 (Prohibition of Rights and Obligations Transfer)

Users may not transfer, sublease, or provide as collateral their right to use the Service to third parties.

## Article 9 (Notifications)

Notifications from the Service shall be made through display within the Service or other methods deemed appropriate. Notification content shall be considered effective immediately after display.

## Article 10 (Display of Advertisements)

The Service may display advertisements in the user's environment.

## Article 11 (Changes to Terms of Service)

1. The Service may change these Terms when deemed appropriate for users' general interests or when deemed necessary.
2. Changes to these Terms shall be notified in advance, and if users continue to use the Service after notification, they shall be deemed to have agreed to the changed Terms.

## Article 12 (Supplementary Provisions)

These Terms shall be effective from the time they are published within the Service.
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyJa; 